module.exports = __webpack_public_path__ + "static/media/logo.e4909e7c.svg";